import type { TourStepDef } from './types';

export const APP_TOUR_STEPS: TourStepDef[] = [
  {
    id: 'nav-overview',
    target: '[data-tour="nav-eventos"]',
    route: '/eventos',
    titleKey: 'appTour.steps.navOverview.title',
    bodyKey: 'appTour.steps.navOverview.body',
    advanceOn: 'next',
    side: 'top',
  },
  {
    id: 'events-home',
    target: '[data-tour="events-hero"]',
    route: '/eventos',
    titleKey: 'appTour.steps.eventsHome.title',
    bodyKey: 'appTour.steps.eventsHome.body',
    advanceOn: 'next',
    side: 'bottom',
  },
  {
    id: 'events-discover',
    target: '[data-tour="events-filters"]',
    route: '/eventos',
    titleKey: 'appTour.steps.eventsDiscover.title',
    bodyKey: 'appTour.steps.eventsDiscover.body',
    advanceOn: 'next',
    side: 'bottom',
  },
  {
    id: 'nav-networking',
    target: '[data-tour="nav-chats"]',
    expectedRoute: '/chats',
    titleKey: 'appTour.steps.navNetworking.title',
    bodyKey: 'appTour.steps.navNetworking.body',
    advanceOn: 'route',
    side: 'top',
  },
  {
    id: 'networking-hub',
    target: '[data-tour="chats-main-tabs"]',
    route: '/chats',
    titleKey: 'appTour.steps.networkingHub.title',
    bodyKey: 'appTour.steps.networkingHub.body',
    advanceOn: 'next',
    side: 'bottom',
  },
  {
    id: 'nav-profile',
    target: '[data-tour="nav-perfil"]',
    expectedRoute: '/perfil',
    titleKey: 'appTour.steps.navProfile.title',
    bodyKey: 'appTour.steps.navProfile.body',
    advanceOn: 'route',
    side: 'top',
  },
  {
    id: 'profile-complete',
    target: '[data-tour="profile-header"]',
    route: '/perfil',
    titleKey: 'appTour.steps.profileComplete.title',
    bodyKey: 'appTour.steps.profileComplete.body',
    advanceOn: 'next',
    side: 'bottom',
  },
];
